module.exports = __webpack_public_path__ + "media/images/application/template/meganav/specialised-containers/used-office-2ed88e0877552f3080a8a35bd961b9d3.png";